/* eslint-disable */
import { useEffect, useState, useContext } from 'react'
import styles from './index.module.scss'
import img from '../../assets/images/success.svg'
import { Button } from '../../components/core/button'
import { PageContext } from '../../context/PageContextProvider'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'

const SuccessDefault = ({ className }) => {
  const { language } = useContext(PageContext)
  const DEFAULT_DATA = {
    title: {
      AZ: 'Müraciətiniz qəbul edildi',
      ENG: 'Application Received',
      RU: 'Заявка принята',
      TR: 'Başvurunuz Alındı',
    },
    description_az: 'Müraciətiniz uğurla qeydə alındı. Tezliklə sizinlə əlaqə saxlayacağıq.',
    description_eng: 'Your application has been successfully received. We will contact you soon.',
    description_ru: 'Ваша заявка успешно принята. Мы свяжемся с вами в ближайшее время.',
    description_tr: 'Başvurunuz başarıyla kaydedildi. En kısa sürede sizinle iletişime geçeceğiz.',
  }
  const [load, setLoad] = useState(true)
  const [data, setData] = useState(DEFAULT_DATA)
  useEffect(() => {
    (async () => {
      try {
        const res = await PagesAPI.getSuccess()
        if (res?.data?.title) {
          setData(res.data)
        }
      } catch (e) {
        console.warn('Using default success data')
      }
    })()
  }, [])
  const home = {
    AZ: 'Ana Səhifə',
    ENG: 'Home',
    RU: 'Главная страница',
    TR: 'Ana Sayfa',
  }
  return load ? (
    <section className={`${styles.container} ${className}`}>
      <div className={styles.content}>
        <img src={img} alt="Success" />
        <h1>{data?.title?.[language] || data?.title?.TR || data?.title?.AZ || ''}</h1>
        <p
          dangerouslySetInnerHTML={{
            __html:
              language === 'AZ'
                ? data?.description_az
                : language === 'TR'
                ? (data?.description_tr || data?.description_az)
                : language === 'ENG'
                ? data?.description_eng
                : (data?.description_ru || data?.description_az),
          }}
        />
        <Button to={'/'}>{home[language] || home.TR || home.AZ}</Button>
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default SuccessDefault
